import { useEffect, useState, useCallback } from 'react';
import { listMockups, removeMockup, updateMockup, getCode, setCode, clearCode, lockMessage } from '../api/lionjob';
import LionjobPager from '../components/LionjobPager';

// KHO MOCKUP — ảnh nhặt từ web bất kỳ bằng extension 🖼, đã TẢI VỀ server
// (không giữ link gốc vì store đối thủ hay chặn hotlink / đổi ảnh).
const fmtKB = (b) => (b ? Math.round(b / 1024) + ' KB' : '—');

export default function MockupPage() {
  const [unlocked, setUnlocked] = useState(false);
  const [codeInput, setCodeInput] = useState('');
  const [lockErr, setLockErr] = useState('');
  const [unlocking, setUnlocking] = useState(false);

  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({ page: 1, totalPages: 1, total: 0 });
  const [domains, setDomains] = useState([]);
  const [page, setPage] = useState(1);
  const [domain, setDomain] = useState('all');
  const [q, setQ] = useState('');
  const [msg, setMsg] = useState('');
  const [zoom, setZoom] = useState(null);
  const [extReady, setExtReady] = useState(false);

  const load = useCallback(async () => {
    try {
      const d = await listMockups({ page, limit: 40, domain, q: q || undefined });
      setRows(d.rows); setDomains(d.domains || []);
      setMeta({ page: d.page, totalPages: d.totalPages, total: d.total });
      setUnlocked(true);
    } catch (e) {
      const m = e.response?.data?.message || e.message || 'Không kết nối được backend';
      if (e.response?.status === 403) { clearCode(); setUnlocked(false); }
      setLockErr(lockMessage(e)); setMsg('Lỗi: ' + m);
    }
  }, [page, domain, q]);

  useEffect(() => { if (unlocked) load(); }, [load, unlocked]);
  useEffect(() => { if (getCode()) load(); /* eslint-disable-next-line */ }, []);
  useEffect(() => {
    const onMsg = (ev) => {
      if (ev.source === window && ev.data?.source === 'lionjob-ext' && ev.data.type === 'ready') setExtReady(true);
    };
    window.addEventListener('message', onMsg);
    window.postMessage({ source: 'lionjob-page', type: 'ping' }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);

  async function unlock(e) {
    e?.preventDefault();
    const c = codeInput.trim(); if (!c) { setLockErr('Nhập mã code'); return; }
    setLockErr(''); setCode(c); setUnlocking(true);
    try { await load(); } finally { setUnlocking(false); }
  }

  async function del(m) {
    if (!window.confirm(`Xoá ảnh này khỏi kho?\n${m.title || m.sourceUrl}`)) return;
    try { await removeMockup(m.id); setMsg('✓ Đã xoá ảnh'); setZoom(null); load(); }
    catch (e) { setMsg('Lỗi xoá: ' + (e.response?.data?.message || e.message)); }
  }
  async function saveNote(m, note) {
    try { await updateMockup(m.id, { note }); setMsg('✓ Đã lưu ghi chú'); load(); }
    catch (e) { setMsg('Lỗi: ' + (e.response?.data?.message || e.message)); }
  }
  function copyUrl(m) {
    navigator.clipboard.writeText(window.location.origin + m.url);
    setMsg('✓ Đã copy đường dẫn ảnh');
  }

  if (!unlocked) {
    return (
      <div className="mk-root"><style>{CSS}</style>
        <div className="mk-lock"><div className="mk-lockCard">
          <div className="mk-lockIco">🦁</div><h2>Kho mockup</h2>
          <p className="mk-lockSub">Khu vực chỉ dành cho Giám đốc. Nhập mã code để mở.</p>
          <form onSubmit={unlock}>
            <input className="mk-lockInput" type="password" autoFocus placeholder="Mã code" disabled={unlocking}
              value={codeInput} onChange={(e) => setCodeInput(e.target.value)} />
            <button className="mk-btn primary" type="submit" disabled={unlocking} style={{ width: '100%', marginTop: 10 }}>
              {unlocking ? '⏳ Đang kết nối…' : 'Mở khóa'}</button>
          </form>
          {lockErr && <div className="mk-lockErr">⚠ {lockErr}</div>}
        </div></div>
      </div>
    );
  }

  return (
    <div className="mk-root"><style>{CSS}</style>
      <div className="mk-head">
        <div>
          <h2>Kho mockup</h2>
          <div className="mk-sub">{msg || `${meta.total} ảnh · nhặt bằng extension 🖼 rồi tải về server, không phụ thuộc link gốc.`}</div>
        </div>
        <div className="mk-sp" />
        <select className="mk-fld" value={domain} onChange={(e) => { setDomain(e.target.value); setPage(1); }}>
          <option value="all">Tất cả nguồn</option>
          {domains.map((d) => <option key={d.name} value={d.name}>{d.name} ({d.n})</option>)}
        </select>
        <input className="mk-fld" placeholder="Tìm theo mô tả…" value={q} onChange={(e) => { setQ(e.target.value); setPage(1); }} />
      </div>

      {rows.length === 0 ? (
        <div className="mk-empty">
          <div style={{ fontSize: 34, marginBottom: 8 }}>🖼</div>
          <b>Kho chưa có ảnh nào</b>
          <p>Bấm icon <b>🦁</b> trên trình duyệt → <b>“🖼 Nhặt ảnh mockup trang đang mở”</b>,
            rồi bấm vào các ảnh muốn lấy và lưu về kho.</p>
          {!extReady && <p className="mk-warn">Chưa thấy extension 🦁 — cài extension trước.</p>}
        </div>
      ) : (
        <div className="mk-grid">
          {rows.map((m) => (
            <figure key={m.id} className="mk-card" onClick={() => setZoom(m)}>
              <img src={m.url} alt={m.title} loading="lazy" />
              <figcaption>
                <div className="mk-t">{m.title || '(không có mô tả)'}</div>
                <div className="mk-m">{m.domain} · {m.width}×{m.height} · {fmtKB(m.bytes)}</div>
                {m.note && <div className="mk-note">{m.note}</div>}
              </figcaption>
            </figure>
          ))}
        </div>
      )}

      <LionjobPager page={meta.page} totalPages={meta.totalPages} onGo={setPage} />

      {zoom && (
        <div className="mk-modal" onClick={() => setZoom(null)}>
          <div className="mk-box" onClick={(e) => e.stopPropagation()}>
            <img src={zoom.url} alt={zoom.title} />
            <div className="mk-info">
              <div className="mk-t big">{zoom.title || '(không có mô tả)'}</div>
              <div className="mk-m">{zoom.domain} · {zoom.width}×{zoom.height} · {fmtKB(zoom.bytes)} · {zoom.mime}</div>
              <label className="mk-lab">Ghi chú</label>
              <input className="mk-fld wide" defaultValue={zoom.note || ''} placeholder="vd: dùng cho áo thêu mùa thu"
                onBlur={(e) => e.target.value !== (zoom.note || '') && saveNote(zoom, e.target.value)} />
              <div className="mk-acts">
                <button className="mk-btn" onClick={() => copyUrl(zoom)}>⧉ Copy đường dẫn</button>
                <a className="mk-btn" href={zoom.url} download target="_blank" rel="noreferrer">⤓ Tải về</a>
                {zoom.pageUrl && <a className="mk-btn" href={zoom.pageUrl} target="_blank" rel="noreferrer">↗ Trang gốc</a>}
                <div style={{ flex: 1 }} />
                <button className="mk-btn danger" onClick={() => del(zoom)}>Xoá</button>
                <button className="mk-btn" onClick={() => setZoom(null)}>Đóng</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const CSS = `
.mk-root{color:var(--text);padding-bottom:30px}
.mk-head{display:flex;gap:10px;align-items:flex-start;margin-bottom:14px;flex-wrap:wrap}
.mk-head h2{margin:0;font-size:20px}
.mk-sub{color:var(--muted);font-size:12.5px;margin-top:3px;max-width:70ch}
.mk-sp{flex:1}
.mk-fld{border:1px solid var(--border);background:var(--input);color:var(--text);font:inherit;font-size:12px;padding:7px 10px;border-radius:8px}
.mk-fld.wide{width:100%;margin-top:4px}
.mk-btn{background:var(--panel);color:var(--text);border:1px solid var(--border);padding:7px 12px;border-radius:9px;cursor:pointer;font-size:13px;text-decoration:none;display:inline-flex;align-items:center;gap:5px}
.mk-btn:hover{border-color:var(--accent)}
.mk-btn.primary{background:var(--accent);border-color:var(--accent);color:#fff;font-weight:600}
.mk-btn.danger{color:var(--danger);border-color:var(--danger)}

.mk-empty{border:1px dashed var(--border);border-radius:var(--radius);padding:48px 24px;text-align:center;color:var(--muted)}
.mk-empty b{color:var(--text);display:block;margin-bottom:6px}
.mk-empty p{font-size:13px;margin:0 auto;max-width:52ch}
.mk-warn{color:var(--warn);margin-top:10px}

.mk-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(170px,1fr));gap:12px}
.mk-card{margin:0;background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);overflow:hidden;cursor:pointer;transition:border-color .12s,transform .12s}
.mk-card:hover{border-color:var(--accent);transform:translateY(-1px)}
.mk-card img{width:100%;aspect-ratio:1;object-fit:cover;display:block;background:var(--input)}
.mk-card figcaption{padding:7px 9px}
.mk-t{font-size:12px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.mk-t.big{font-size:14px;white-space:normal}
.mk-m{font-size:10.5px;color:var(--muted);margin-top:2px;font-family:var(--font-mono)}
.mk-note{font-size:11px;color:var(--accent);margin-top:3px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.mk-lab{display:block;font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:var(--muted);margin-top:12px;font-weight:600}

.mk-modal{position:fixed;inset:0;background:rgba(8,11,20,.72);display:flex;align-items:center;justify-content:center;padding:24px;z-index:1000}
.mk-box{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);max-width:900px;width:100%;max-height:88vh;overflow:auto;display:grid;grid-template-columns:minmax(0,1.2fr) minmax(260px,1fr)}
.mk-box img{width:100%;height:100%;max-height:88vh;object-fit:contain;background:var(--input)}
.mk-info{padding:16px 18px}
.mk-acts{display:flex;gap:8px;flex-wrap:wrap;margin-top:16px;align-items:center}
@media (max-width:720px){.mk-box{grid-template-columns:1fr}}

.mk-lock{display:flex;justify-content:center;padding:60px 20px}
.mk-lockCard{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:28px 26px;width:340px;text-align:center}
.mk-lockIco{font-size:38px;line-height:1}.mk-lockCard h2{margin:8px 0 4px}
.mk-lockSub{color:var(--muted);font-size:13px;margin:0 0 16px}
.mk-lockInput{width:100%;background:var(--input);color:var(--text);border:1px solid var(--border);border-radius:10px;padding:10px 12px;font-size:14px;text-align:center;letter-spacing:2px}
.mk-lockErr{color:var(--danger);font-size:12px;margin-top:10px}
`;
